const isCheckhq = () => window.partner === "checkhq" || window.location.pathname.slice(0, 8) === "/checkhq";

export default isCheckhq;
